var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerificar360 = function SvgVerificar360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verificar360_svg__a)",
    fillRule: "evenodd",
    d: "M10 21a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 1 1-4 0h-8a2 2 0 1 1-4 0 2 2 0 0 1-2-2zm3 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m15-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verificar360_svg__b)",
    fillRule: "evenodd",
    d: "M12.579 17H27.42l-1.116-2.975A1.58 1.58 0 0 0 24.827 13h-9.654c-.658 0-1.247.408-1.478 1.025z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#verificar360_svg__c)",
    fillRule: "evenodd",
    d: "M20.576 1a1 1 0 0 0 0 2c1.5 0 2.953.214 4.33.613 6.865 1.99 11.954 8.621 11.954 16.545 0 3.447-.686 6.08-2.031 8.467-1.347 2.389-3.384 4.587-6.2 7.127v-2.64a1 1 0 1 0-2 0V38a1 1 0 0 0 1 1h4.89a1 1 0 1 0 0-2H30.23c2.74-2.494 4.879-4.802 6.34-7.393 1.535-2.725 2.29-5.704 2.29-9.45 0-8.778-5.645-16.217-13.397-18.465A17.5 17.5 0 0 0 20.576 1M4.445 4.594a1 1 0 1 0-.001 2l2.198.001C3.245 9.998 1.14 14.744 1.14 19.99c0 9.008 6.214 16.554 14.525 18.334a1 1 0 1 0 .419-1.956C8.709 34.788 3.14 28.07 3.14 19.99c0-4.841 2-9.196 5.191-12.249l.002 2.743a1 1 0 1 0 2-.001l-.003-4.886a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "verificar360_svg__a",
    x1: 20,
    x2: 20,
    y1: 27,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "verificar360_svg__b",
    x1: 20,
    x2: 20,
    y1: 17,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "verificar360_svg__c",
    x1: 20,
    x2: 20,
    y1: 39,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgVerificar360;